<template>
	<header ref="headerRef">
		<slot>
			<hero-image :item="headingImage" />
		</slot>
	</header>
</template>

<script setup>
const headerRef = ref(null);
const height = ref(0);
let resizeObserver = null;

const updateHeight = () => {
	if (headerRef.value) {
		height.value = headerRef.value.offsetHeight;
	}
};

onMounted(() => {
	nextTick(() => {
		updateHeight();

		resizeObserver = new ResizeObserver(() => {
			updateHeight();
		});

		if (headerRef.value) {
			resizeObserver.observe(headerRef.value);
		}
	});
});

onUnmounted(() => {
	if (resizeObserver && headerRef.value) {
		resizeObserver.unobserve(headerRef.value);
		resizeObserver.disconnect();
	}
});

defineExpose({ height });

defineProps({
	headingImage: {
		type: Object,
		default: () => ({
			imageWebp: '',
			image: '',
			imageAlt: '',
		}),
	},
	type: {
		type: String,
		default: 'small',
	},
});
</script>

<style lang="scss" scoped>
header {
	position: relative;
}
</style>
